/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Notifications_user = {
    readonly preferences: {
        readonly shareActivities: boolean | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ShareActivityAlert_user" | "ActivityFeed_user" | "NotificationsIcon_user">;
    readonly " $refType": "Notifications_user";
};
export type Notifications_user$data = Notifications_user;
export type Notifications_user$key = {
    readonly " $data"?: Notifications_user$data;
    readonly " $fragmentRefs": FragmentRefs<"Notifications_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Notifications_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "preferences",
      "storageKey": null,
      "args": null,
      "concreteType": "UserPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "shareActivities",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "Defer",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ShareActivityAlert_user",
              "args": null
            }
          ]
        },
        {
          "kind": "Defer",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ActivityFeed_user",
              "args": null
            }
          ]
        },
        {
          "kind": "Defer",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "NotificationsIcon_user",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'b6a51da8722acc22b81a7a70bd63ea2a';
export default node;
